var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCommonLanguages(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-1206.000000, -435.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Common/Languages",
    transform: "translate(1206.000000, 435.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.49998125,0.5 C2.32897089,0.5 2.9999625,1.15003125 2.9999625,1.953125 L2.9999625,1.953125 L2.9999625,31.5 L0,31.5 L0,1.953125 C0,1.15003125 0.670991613,0.5 1.49998125,0.5 Z M11.4998563,15.03125 C12.3288459,15.03125 12.9998375,15.6812812 12.9998375,16.484375 L12.9998375,16.484375 L12.9998375,31.5 L9.999875,31.5 L9.999875,16.484375 C9.999875,15.6812812 10.6708666,15.03125 11.4998563,15.03125 Z M14.3372208,16.0808906 C17.0542637,14.4028666 19.7715197,15.0482604 22.4888904,15.8723788 L23.1682354,16.0808906 C26.1120736,16.9898203 29.0560368,17.89875 32,16.0808906 L32,16.0808906 L32,26.7758906 C26.1120736,30.4106406 20.2241472,23.1392031 14.3372208,26.7758906 L14.3372208,26.7758906 Z M4.33694579,1.54964063 C10.2248722,-2.08607812 16.1117986,5.18535938 21.999725,1.54964063 L21.999725,1.54964063 L21.999725,12.2436719 C16.1117986,15.8793906 10.2248722,8.60795313 4.33694579,12.2436719 L4.33694579,12.2436719 Z",
    id: 225
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonLanguages);
export default __webpack_public_path__ + "static/media/common-languages.d2842250.svg";
export { ForwardRef as ReactComponent };